import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { ExpertComponent } from './expert.component';
import { AgentComponent } from './agent/agent.component';
import { GroupComponent } from './group/group.component';
import { OrganizationComponent } from './organization/organization.component';

export const ExpertSettingsRoute = [
  {
    path: 'expert',
    component: ExpertComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'agent', pathMatch: 'full' },
      { path: 'agent', component: AgentComponent, canActivate: [AuthGuard] },
      {
        path: 'group',
        component: GroupComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'organization',
        component: OrganizationComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/expert.route.ts